module.exports = __webpack_public_path__ + "assets/img/6a3485abfaa8d59690210fc7f506654d.png";